<template>
<div class="l-qa">
  <Text class="c-text-xl" text="よくある質問"></Text>
  <Accordion v-for="text in texts"
            :key="text.key"
            type="qa"
            :headText="text.q"
            :bodyText="text.a">
  </Accordion>
</div>
</template>

<script>
import Text from '@/components/atoms/Text.vue'
import Accordion from '@/components/modules/Accordion.vue'
export default {
  components: {
    Text,
    Accordion
  },
  data () {
    return {
      texts: {
        qa01: {
          q: '推奨ブラウザは？',
          a: `最新のGoogle ChromeまたFirefoxを推奨しています。
Safari / Microsoft Edge / Internet Explorer等 はサポートしていません。`
        },
        qa02: {
          q: 'つくられる画像のサイズは？',
          a: '横1200px　縦800pxです。よくあるサムネイル画像のアスペクト比と同じです。'
        },
        qa03: {
          q: '作られるまでの待ち時間は？',
          a: `[ 画像からつくった場合 ] 一瞬でできます。
[ URLからつくった場合 ] 通常10秒〜1分程度です。
通信状態やサイトの表示速度によって前後します。
URLからつくった場合でも、同じURLで連続して生成すると、一瞬でできます。`
        },
        qa04: {
          q: 'スマホでも保存できるようにしたら？',
          a: `現在はスマホでの保存に対応する予定はありません。
ご要望が多い場合は、実現方法の検討をさせていただきます。`
        },
        qa11: {
          q: '画像から作ると、フレームにサイズが合わなかったら？',
          a: `アップロードする画像のアスペクト比をご確認ください。
[ PC ] 横：縦 = 1.6：1（例：800px：1280px）
[ スマホ ] 横：縦 = 1：2.16（例：375px：812px）
を推奨しています。
これらは一般的なPC・スマホの画面サイズと同じ比率です。`
        },
        qa12: {
          q: '「うまくいきませんでした」というメッセージがでたら？',
          a: `[1] URLが間違っていないかご確認ください。
正しい場合は https:// と http:// を入れ替えて再度お試しください。

[2] Basic認証はかかっていますか？
Basic認証がかかっていると生成できません。
認証を除いてからお試しください。

[3] 1、２でうまく行かない場合
Google拡張機能が影響している可能性があります。
お手数ですが、a, bを行ってから、再度お試しください。

a. Googleブラウザの拡張機能をすべてオフに
b. ハードリロードを行ってWorks Thumbnail Generatorを再読み込み

上記を行った上で、万が一うまく行かない場合は、運営にご連絡をお願いいたします🙏
原因追求と改善に努めさせていただきます。`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.l-qa {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
